import React from "react";

const FeaturedBlog = ({
  section,
  title,
  description,
  image,
  link,
  author,
  date,
}) => {
  return (
    <div className="mb-16 bg-gradient-to-r from-gray-50 to-white rounded-3xl p-8 shadow-lg">
      <div className="flex items-center mb-6">
        <div className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold mr-4">
          FEATURED
        </div>
      </div>

      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col lg:flex-row gap-8 text-black no-underline group"
      >
        <div className="lg:w-1/2">
          <img
            src={image}
            alt={title}
            className="w-full h-64 lg:h-80 rounded-2xl object-cover"
          />
        </div>

        <div className="lg:w-1/2 flex flex-col justify-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight group-hover:text-blue-600 transition-colors duration-300">
            {title}
          </h2>

          {description && (
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {description}
            </p>
          )}

          <div className="flex items-center justify-between">
            <div>
              {author && date && (
                <p className="text-gray-500 text-sm">
                  {author} | {date}
                </p>
              )}
              {!author && date && (
                <p className="text-gray-500 text-sm">{date}</p>
              )}
            </div>

            <div className="flex items-center text-blue-600 font-semibold group-hover:translate-x-2 transition-transform duration-300">
              Read More
              <svg
                className="ml-2 w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default FeaturedBlog;
